/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BidIncrementsDto } from '../models/bid-increments-dto';
import { getBidIncrements } from '../fn/bid-increment/get-bid-increments';
import { GetBidIncrements$Params } from '../fn/bid-increment/get-bid-increments';

@Injectable({ providedIn: 'root' })
export class GeneratedBidIncrementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBidIncrements()` */
  static readonly GetBidIncrementsPath = '/api/bid-increments';

  /**
   * Gets all bid increments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidIncrements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidIncrements$Response(params?: GetBidIncrements$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BidIncrementsDto>>> {
    return getBidIncrements(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all bid increments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidIncrements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidIncrements(params?: GetBidIncrements$Params, context?: HttpContext): Observable<Array<BidIncrementsDto>> {
    return this.getBidIncrements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BidIncrementsDto>>): Array<BidIncrementsDto> => r.body)
    );
  }

}
